import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { AppState } from '~/reducers';
import i18nLoader from '~/utils/I18nLoader/I18nLoader';
import LinkBlankTarget from '~/components/views/LinkBlankTarget/LinkBlankTarget';
import FormattedMessageWrapper from '~/components/views/FormattedMessageWrapper/FormattedMessageWrapper';
import ListButton from '~/components/views/common/buttons/ListButton/ListButton';
import LocalStorageUtils from '~/utils/local-storage-utils/local-storage-utils';
import paths from '~/app/paths/paths';
import * as S from './styled';

interface Props {
  loadedLocale?: string;
}

export class AcceptCookiesContainer extends PureComponent<Props> {
  clickHandler = () => {
    LocalStorageUtils.setAcceptedCookies();
    this.forceUpdate();
  };

  isCookiesAccepted = () => {
    return LocalStorageUtils.getAcceptedCookies() === 'yes';
  };

  render() {
    if (this.isCookiesAccepted() || !this.props.loadedLocale) {
      return null;
    }

    return (
      <S.AcceptCookiesContainerDiv>
        <FormattedMessageWrapper
          langKey="web.accept_cookies.text"
          values={{
            cookiePolicyLink: (
              <LinkBlankTarget
                href={paths.cookiePolicy.getPath()}
                useNoreferrer={false}
                trackingLabel="CookiePolicy"
              >
                <FormattedMessageWrapper langKey="web.accept_cookies.policy_link" />
              </LinkBlankTarget>
            ),
          }}
        />
        <ListButton
          text={i18nLoader.getWithDefault('web.accept_cookies.button')}
          onClick={this.clickHandler}
        />
      </S.AcceptCookiesContainerDiv>
    );
  }
}

const mapStateToProps = ({ translation }: AppState): Props => ({
  loadedLocale: translation.loadedLocale,
});

export default connect(mapStateToProps)(AcceptCookiesContainer);
